var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGirdedExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "girded-exclamation"
  }, /*#__PURE__*/React.createElement("path", {
    id: "girded-exclamation_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16ZM6.501 12.53C6.53262 13.349 7.20439 13.9974 8.024 14H8.051C8.44738 13.9933 8.82438 13.8273 9.09698 13.5395C9.36958 13.2516 9.51484 12.8662 9.5 12.47C9.46939 11.6505 8.79702 11.0016 7.977 11H7.95C7.55371 11.007 7.17687 11.1731 6.90433 11.4608C6.63179 11.7486 6.48644 12.1339 6.501 12.53ZM7 3C7 2.44772 7.44772 2 8 2C8.55229 2 9 2.44772 9 3V8.5C9 9.05229 8.55229 9.5 8 9.5C7.44772 9.5 7 9.05229 7 8.5V3Z",
    fill: "#FF6400"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirdedExclamation);
export default __webpack_public_path__ + "static/media/girded-exclamation.050b3c0a937238d8cdf2874253ba23be.svg";
export { ForwardRef as ReactComponent };